import { getProvincias } from '../api/geo';
import { getResults } from '../api/contents'
import { Dispatch } from 'redux';
import { EventsData, provincia, textAyuda } from '../types/types';
import { getAyuda, getTelefonoAyuda } from '../api/helpText';
import {GenericObject} from '../types/types';

const initialState = {
    provincias: null,
    textoAyuda: '',
    resultadosBusqueda: null,
    buscandoResultados: false,
    telefonoAyuda:'',
    tituloModalAyuda:'AYUDA',
    error: null,
    mensajeError:''
};

const PROVINCIAS = 'PROVINCIAS'
const TEXTOAYUDA = 'TEXTOAYUDA'
const RESULTADOSBUSQUEDA = 'RESULTADOSBUSQUEDA'
const BUSCANDORESULTADOS = 'BUSCANDORESULTADOS'
const TELEFONOAYUDA = 'TELEFONOAYUDA'
const TITULOMODALAYUDA = 'TITULOMODALAYUDA'
const ERROR = 'ERROR'


const setProvincias = (provincias: provincia[] | null) => ({ type: PROVINCIAS, payload: provincias });
const setAyuda = (txt: string) => ({ type: TEXTOAYUDA, payload: txt })
const setResultadosBusqueda = (resultados: EventsData | null) => ({ type: RESULTADOSBUSQUEDA, payload: resultados });
const setBuscandoResultados = (buscando: boolean) => ({ type: BUSCANDORESULTADOS, payload: buscando });
const setTelefonoAyuda = (telefono: string) => ({ type: TELEFONOAYUDA, payload: telefono })
const setTituloModalAyuda = (tituloModalAyuda:string) => ({type: TITULOMODALAYUDA, payload: tituloModalAyuda})
const setMensajeError = (errorObjet:GenericObject | null) => ({type: ERROR, payload: errorObjet})

export const fetchProvincias = () => {
    return async (dispatch: Dispatch) => {
        try {
            const res = await getProvincias();
            dispatch(setProvincias(res));
        } catch (error) {
            console.log('Error al obtener provincias:', error);
        }
    }
}

export const fetchTextoAyuda = (path: string, modalTitle?:string) => {
    return async (dispatch: Dispatch) => {
        if (path === '') {
            dispatch(setAyuda(''));
            return;
        }
        try {
            const res: textAyuda = await getAyuda(path);
            dispatch(setAyuda(res.text));

            if(modalTitle){
                dispatch(setTituloModalAyuda(modalTitle))
            }else{
                dispatch(setTituloModalAyuda('AYUDA'))
            }

        } catch (error) {
            console.log('Error al obtener ayuda:', error);
        }
    }
}

// Estado del buscador, compartido por los dos buscadores de la app. Vive fuera
// del store porque no se renderiza: sirve para agrupar las teclas en un solo
// request, cancelar el anterior y descartar respuestas que llegan tarde.
const DEBOUNCE_BUSQUEDA_MS = 300;
const MAX_BUSQUEDAS_CACHEADAS = 50;

let timerBusqueda: ReturnType<typeof setTimeout> | null = null;
let busquedaEnCurso: AbortController | null = null;
let ultimaBusqueda = '';
const cacheBusquedas = new Map<string, EventsData>();

export const fetchResultadosBusqueda = (query: string) => {
    return async (dispatch: Dispatch) => {
        const busqueda = query.trim();

        // lo que se haya pedido antes queda obsoleto
        if (timerBusqueda) {
            clearTimeout(timerBusqueda);
            timerBusqueda = null;
        }
        if (busquedaEnCurso) {
            busquedaEnCurso.abort();
            busquedaEnCurso = null;
        }

        ultimaBusqueda = busqueda;

        if (busqueda === '') {
            dispatch(setBuscandoResultados(false));
            return dispatch(setResultadosBusqueda(null));
        }

        const cacheada = cacheBusquedas.get(busqueda);
        if (cacheada) {
            dispatch(setBuscandoResultados(false));
            return dispatch(setResultadosBusqueda(cacheada));
        }

        dispatch(setBuscandoResultados(true));

        timerBusqueda = setTimeout(async () => {
            const controller = new AbortController();
            busquedaEnCurso = controller;

            try {
                const res = await getResults(busqueda, controller.signal);

                // una busqueda mas nueva ya tomo el control
                if (controller.signal.aborted || ultimaBusqueda !== busqueda) {
                    return;
                }

                if (cacheBusquedas.size >= MAX_BUSQUEDAS_CACHEADAS) {
                    cacheBusquedas.clear();
                }
                cacheBusquedas.set(busqueda, res);

                dispatch(setResultadosBusqueda(res));
                dispatch(setBuscandoResultados(false));
            } catch (error) {
                if (controller.signal.aborted || ultimaBusqueda !== busqueda) {
                    return;
                }
                console.log('Error al obtener resultados:', error);
                // sin esto el spinner queda girando para siempre
                dispatch(setBuscandoResultados(false));
            } finally {
                if (busquedaEnCurso === controller) {
                    busquedaEnCurso = null;
                }
            }
        }, DEBOUNCE_BUSQUEDA_MS);
    }
}

export const fetchTelefonoAyuda = () => {
    return async (dispatch: Dispatch) => {
        try {
            const res:textAyuda = await getTelefonoAyuda();
            dispatch(setTelefonoAyuda(res.text));
        } catch (error) {
            console.log('Error al obtener telefono:', error);
        }
    }
}

export const mostrarError = (errorObjet:GenericObject | null, mensaje?:string) => {
    return (dispatch: Dispatch) => {
      return dispatch(setMensajeError(errorObjet))
    }
  }

const configReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case PROVINCIAS:
            return { ...state, provincias: action.payload };
        case TEXTOAYUDA:
            return { ...state, textoAyuda: action.payload };
        case TITULOMODALAYUDA:
            return { ...state, tituloModalAyuda: action.payload };
        case TELEFONOAYUDA:
                return { ...state, telefonoAyuda: action.payload };
        case RESULTADOSBUSQUEDA:
            return { ...state, resultadosBusqueda: action.payload };
        case BUSCANDORESULTADOS:
            return { ...state, buscandoResultados: action.payload };
        case ERROR:
            return {...state, error: action.payload}
        default:
            return { ...state };
    }
}

export default configReducer;